import { render, staticRenderFns } from "./warningList.vue?vue&type=template&id=5545ecf8&scoped=true"
import script from "./warningList.vue?vue&type=script&lang=js"
export * from "./warningList.vue?vue&type=script&lang=js"
import style0 from "./warningList.vue?vue&type=style&index=0&id=5545ecf8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5545ecf8",
  null
  
)

export default component.exports